import React from 'react';
import { useSelector } from 'react-redux';
import CurrencyFormat from 'react-currency-format';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { dateTimeToString } from '../../common/utils/date/Date.utils';
import { AuctionStatus } from '../../constants/AuctionStatus';
import crossIcon from '../../assets/img/icons/cross-primary.svg';
import { BidStatus } from '../../constants/BidStatus';
import { formatOrganizationLocation } from '../../helpers/formatOrganizationLocation';

function VehicleBidsLaunchTableRow({ item, showRemoveItemAlert }) {
  const { id, bidder, bidderLocation, amountInPence, createdOn, status } = item;
  const { firstName, lastName, organization } = bidder;

  const bidderFullName = `${firstName} ${lastName}`;
  const auctionStatus = useSelector((state) => state.vehicles.get('auctionDetails'))?.status;

  const isWon = String(status).toUpperCase() === BidStatus.WON;
  const isWaiting = String(status).toUpperCase() === BidStatus.WAITING;

  const getBidRowStyle = () => {
    if (isWon) return 'vehicle-bid-row--won';
    if (isWaiting) return 'vehicle-bid-row--waiting';
    return null;
  };

  return (
    <>
      <td className={getBidRowStyle()}>{organization?.tradeName}</td>
      <td className={getBidRowStyle()}>{formatOrganizationLocation(bidderLocation) || '-'}</td>
      <td className={getBidRowStyle()}>{bidderFullName}</td>
      <td className={getBidRowStyle()}>
        <CurrencyFormat
          value={(amountInPence ?? 0) / 100}
          thousandSeparator={true}
          allowNegative={false}
          prefix="£"
          displayType="text"
        />
      </td>
      <td className={getBidRowStyle()}>{dateTimeToString(createdOn)}</td>
      <td className={isWon || isWaiting ? `${getBidRowStyle()} text-right` : 'text-right'}>
        <Button
          className="btn-icon rounded-circle btn-ghost-light"
          id={`tooltip${id}`}
          size="sm"
          type="button"
          onClick={() => showRemoveItemAlert(item)}
          disabled={auctionStatus !== AuctionStatus.PUBLISHED}
        >
          <img src={crossIcon} alt="Cross icon" />
        </Button>
      </td>
    </>
  );
}

VehicleBidsLaunchTableRow.propTypes = {
  item: PropTypes.object.isRequired,
  showRemoveItemAlert: PropTypes.func.isRequired,
};

export default VehicleBidsLaunchTableRow;
